(function ($) {
	/**
	 * Swisscom Cookies
	 *
	 * Wrapper for $.cookies (jquery.cookies.2.2.0.min.js)
	 * See documentation on http://code.google.com/p/cookies/wiki/Documentation
	 *
	 * @author Juliane Huber, Thomas Junghans
	 * @namespace $
	 * @class setCookie, getCookie, removeCookie
	 */

	'use strict';

	/**
	 * setCookie
	 *
	 * @param {String} name
	 * @param {*} value
	 * @param {Number} days (optional)
	 * @param {String} path (optional)
	 * @param {String} domain (optional)
	 * @return {*}
	 */
	$.setCookie = function (name, value, days, path, domain) {
		var date;
		if (days && !isNaN(days)) {
			date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
		}
		$.cookies.set(name, value, {
			secure: location.protocol.indexOf('https') >= 0,
			path: path || '/',
			expiresAt: date || '',
			domain: domain || null
		});
		return value;
	};

	/**
	 * getCookie
	 *
	 * @param {String} name
	 * @return {*}
	 */
	$.getCookie = function (name) {
		return $.cookies.get(name);
	};

	/**
	 * removeCookie
	 *
	 * @param {String} name
	 * @param {String} path
	 * @param {String} domain
	 */
	$.removeCookie = function (name, path, domain) {
		$.cookies.del(name, {
			secure: location.protocol.indexOf('https') >= 0,
			path: path || '/',
			domain: domain || null
		});
	};

})(window.$);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/scCookie.js
// module id = 88
// module chunks = 0